import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';
import ChampSelect from '../champs/ChampSelect';

const OPTIONS_ROLE = [
  { valeur: '', label: '— Sélectionner un rôle —' },
  { valeur: 'Chargé d\'étude', label: 'Chargé d\'étude' },
  { valeur: 'Responsable qualité', label: 'Responsable qualité' },
  { valeur: 'Chargé qualité', label: 'Chargé qualité' },
  { valeur: 'Responsable DevCo', label: 'Responsable DevCo' },
  { valeur: 'Président', label: 'Président' },
  { valeur: 'Trésorier', label: 'Trésorier' },
];

const OPTIONS_TYPE_PRESIDENCE = [
  { valeur: 'president', label: 'Président' },
  { valeur: 'co-president', label: 'Co-Président' },
];

const OPTIONS_GENRE = [
  { valeur: 'M', label: 'Masculin' },
  { valeur: 'F', label: 'Féminin' },
];

function SectionInfosI2C({
  typePresidence,
  contacts,
  infoPresident1,
  infoPresident2,
  onChangerTypePresidence,
  onChangerInfoPresident,
  onAjouterContact,
  onSupprimerContact,
  onModifierContact,
}) {
  return (
    <Carte titre="Informations i2c" icone="🏫">
      {/* ── Président(s) ── */}
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: 'var(--texte)' }}>
          Président(s) signataire(s) de la convention
        </div>
        <div className="grille grille--2col">
          <ChampSelect
            label="Type de présidence"
            valeur={typePresidence}
            onChange={(_, val) => onChangerTypePresidence(val)}
            nom="typePresidence"
            options={OPTIONS_TYPE_PRESIDENCE}
          />
        </div>

        {typePresidence === 'president' && (
          <div className="grille grille--2col" style={{ marginTop: 12 }}>
            <ChampTexte
              label="Prénom"
              valeur={infoPresident1.prenom}
              onChange={(_, val) => onChangerInfoPresident('prenom', val)}
              nom="prenom"
              placeholder="Marie"
            />
            <ChampTexte
              label="Nom"
              valeur={infoPresident1.nom}
              onChange={(_, val) => onChangerInfoPresident('nom', val)}
              nom="nom"
              placeholder="Martin"
            />
            <ChampSelect
              label="Genre"
              valeur={infoPresident1.genre}
              onChange={(_, val) => onChangerInfoPresident('genre', val)}
              nom="genre"
              options={OPTIONS_GENRE}
            />
            <ChampTexte
              label="Mail i2c"
              valeur={infoPresident1.mail}
              onChange={(_, val) => onChangerInfoPresident('mail', val)}
              nom="mail"
              placeholder="president@i2c.fr"
              typeMail
            />
          </div>
        )}

        {typePresidence === 'co-president' && (
          <>
            <div style={{ fontSize: 12, fontWeight: 500, marginTop: 16, marginBottom: 8, color: 'var(--texte-secondaire)' }}>
              Co-Président 1
            </div>
            <div className="grille grille--2col">
              <ChampTexte
                label="Prénom"
                valeur={infoPresident1.prenom}
                onChange={(_, val) => onChangerInfoPresident('prenom', val, 1)}
                nom="prenom"
                placeholder="Prénom 1"
              />
              <ChampTexte
                label="Nom"
                valeur={infoPresident1.nom}
                onChange={(_, val) => onChangerInfoPresident('nom', val, 1)}
                nom="nom"
                placeholder="Nom 1"
              />
              <ChampSelect
                label="Genre"
                valeur={infoPresident1.genre}
                onChange={(_, val) => onChangerInfoPresident('genre', val, 1)}
                nom="genre"
                options={OPTIONS_GENRE}
              />
              <ChampTexte
                label="Mail i2c"
                valeur={infoPresident1.mail}
                onChange={(_, val) => onChangerInfoPresident('mail', val, 1)}
                nom="mail"
                placeholder="president@i2c.fr"
                typeMail
              />
            </div>

            <div style={{ fontSize: 12, fontWeight: 500, marginTop: 16, marginBottom: 8, color: 'var(--texte-secondaire)' }}>
              Co-Président 2
            </div>
            <div className="grille grille--2col">
              <ChampTexte
                label="Prénom"
                valeur={infoPresident2.prenom}
                onChange={(_, val) => onChangerInfoPresident('prenom', val, 2)}
                nom="prenom"
                placeholder="Prénom 2"
              />
              <ChampTexte
                label="Nom"
                valeur={infoPresident2.nom}
                onChange={(_, val) => onChangerInfoPresident('nom', val, 2)}
                nom="nom"
                placeholder="Nom 2"
              />
              <ChampSelect
                label="Genre"
                valeur={infoPresident2.genre}
                onChange={(_, val) => onChangerInfoPresident('genre', val, 2)}
                nom="genre"
                options={OPTIONS_GENRE}
              />
              <ChampTexte
                label="Mail i2c"
                valeur={infoPresident2.mail}
                onChange={(_, val) => onChangerInfoPresident('mail', val, 2)}
                nom="mail"
                placeholder="president@i2c.fr"
                typeMail
              />
            </div>
          </>
        )}
      </div>

      {/* ── Contacts pour l'étude ── */}
      <div style={{ borderTop: '1px solid var(--gris-bord)', paddingTop: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: 'var(--texte)' }}>
          Contacts i2c pour l'étude
        </div>

        <div className="liste-dynamique">
          {contacts.map((contact, idx) => (
            <div key={contact.id} className="liste-dynamique__item">
              <div className="liste-dynamique__item-entete">
                <span className="liste-dynamique__item-num">Contact {idx + 1}</span>
                <button
                  className="btn btn--danger btn--sm"
                  onClick={() => onSupprimerContact(contact.id)}
                >
                  ✕ Supprimer
                </button>
              </div>
              <div className="grille grille--2col">
                <ChampTexte
                  label="Prénom"
                  valeur={contact.prenom}
                  onChange={(_, val) => onModifierContact(contact.id, 'prenom', val)}
                  nom="prenom"
                  placeholder="Jean"
                />
                <ChampTexte
                  label="Nom"
                  valeur={contact.nom}
                  onChange={(_, val) => onModifierContact(contact.id, 'nom', val)}
                  nom="nom"
                  placeholder="Dupont"
                />
                <ChampSelect
                  label="Genre"
                  valeur={contact.genre}
                  onChange={(_, val) => onModifierContact(contact.id, 'genre', val)}
                  nom="genre"
                  options={OPTIONS_GENRE}
                />
                <ChampTexte
                  label="Description / Rôle"
                  valeur={contact.description}
                  onChange={(_, val) => onModifierContact(contact.id, 'description', val)}
                  nom="description"
                  placeholder="ex : En apprentissage depuis 5 mois à i2c, je serai l’interlocutrice du client tout au long du projet et veillerai au respect du besoin, des délais et de la qualité des livrables."
                />
                <ChampSelect
                  label="Rôle officiel"
                  valeur={contact.role}
                  onChange={(_, val) => onModifierContact(contact.id, 'role', val)}
                  nom="role"
                  options={OPTIONS_ROLE}
                />
                <ChampTexte
                  label="Mail i2c"
                  valeur={contact.mail}
                  onChange={(_, val) => onModifierContact(contact.id, 'mail', val)}
                  nom="mail"
                  placeholder="prenom.nom@i2c.fr"
                  typeMail
                />
                <ChampTexte
                  label="Téléphone"
                  valeur={contact.tel}
                  onChange={(_, val) => onModifierContact(contact.id, 'tel', val)}
                  nom="tel"
                  placeholder="06 XX XX XX XX"
                  maxLength={10}
                  chiffresUniquement
                />
                <div className="champ" style={{ display: 'flex', flexDirection: 'row', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}>
                  <label>Auteur / Autrice</label>
                  <input
                    type="checkbox"
                    checked={contact.auteur}
                    onChange={(e) => onModifierContact(contact.id, 'auteur', e.target.checked)}
                    nom="auteur"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="btn btn--fantome" style={{ marginTop: 8 }} onClick={onAjouterContact}>
          + Ajouter un contact
        </button>
      </div>
    </Carte>
  );
}

export default SectionInfosI2C;